<template>
    <div class="stamp">
        <div class="par-money">
            <p class="p">{{ shop_name }}</p>
            <span class="span">{{ money }} 元</span> <br />
            <p class="p">项目金额 {{ full_money }}</p>
        </div>
        <div class="copy">
            <span>{{ title }}</span>
            <div>
                <p>{{ begin_date }}</p>
                <p>{{ end_date }}</p>
            </div>
            <div>
                <p>{{ state_name }}</p>
                <p></p>
            </div>
        </div>
        <i></i>
    </div> 
</template>

<script>
export default {
    props: ['shop_name','money','full_money','title','begin_date','end_date','state'],
    data() {
        return {}
    },
    computed: {
        state_name() {
            return (this.state === 0 ? '活动中' : '已终止')
        }
    },
    methods:{}
}
</script>

<style lang="less" scoped>
    .stamp {
        width: 92%;
        height: 140px;
        padding: 0 0px;
        margin: 4%;
        position: relative;
        overflow: hidden;
        p {
            padding: 0;
            margin: 0;
        }
        &:before {
            content: '';
            position: absolute;
            top: 0;
            bottom: 0;
            left: 10px;
            right: 10px;
            z-index: -1;
        }
        i {
            position: absolute;
            left: 20%;
            top: 45px;
            height: 190px;
            width: 390px;
            background-color: rgba(255, 255, 255, 0.15);
            transform: rotate(-30deg);
            -ms-transform: rotate(-30deg);
            -moz-transform: rotate(-30deg);
            -webkit-transform: rotate(-30deg);
            -o-transform: rotate(-30deg);
        }
        .copy {
            padding: 30px 0;
            vertical-align: text-bottom;
            font-size: 18px;
            color: rgb(255, 255, 255);
            text-align: center;
            line-height: initial;
            p:last-child {
                margin-top: 0px;
            }
            p {
                margin-top: 16px;
                font-size: 16px;
            }
        }
        .par-money {
            float: left;
            height: 100%;
            padding: 6% 15px;
            width: 51%;
            border-right: 2px dashed rgba(255, 255, 255, 0.3);
            text-align: left;
            .p {
                color: #fff;
                font-size: 16px;
                line-height: 21px;
                margin: 4px 0;
            }
            .span {
                font-size: 28px;
                color: #fff;
                margin-right: 5px;
                line-height: 34px;
            }
            button {
                position: absolute;
                bottom: 10%;
                left: 40%;
                z-index: 1;
            }
        }
    }
</style>